// hooks/useCategoryIds.ts
import { useFetchCategoriesListQuery } from '../../../entities/Categories/api/supplier/apiCategoriesSlice'
import { useContext, useMemo } from 'react'
import { SupplierContext } from 'context/SupplierContext'

const customer_id = Number(window.config.CUSTOMER_ID)
const parent_id = Number(window.config.CATEGORY_ID)

export default function useCategoryIds() {
  const { is_supplier } = useContext(SupplierContext)

  const { data, isLoading } = useFetchCategoriesListQuery(
    { customer_id, parent_id, is_supplier },
    { skip: !is_supplier || !customer_id } // Пропускаем запрос для не-поставщиков или если нет customer_id
  )

  const categoryIds = useMemo(
    () => data?.data?.map((category: any) => category.id) || [],
    [data]
  )

  return { categoryIds, isLoading }
}
